import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const onFail = (e, { toastErrors, fallback }, setData) => {
  if (toastErrors) toast.error(errMsg(e));
  if (fallback !== undefined) setData(fallback);
};

export const useApi = (path, { initial = null, params, delay = 0, toastErrors = false, fallback } = {}) => {
  const [data, setData] = useState(initial);
  const query = params ? JSON.stringify(params) : "";
  const opts = useRef({ toastErrors, fallback });
  opts.current = { toastErrors, fallback };
  const reload = useCallback(() => {
    const cfg = query ? { params: JSON.parse(query) } : undefined;
    return api.get(path, cfg).then((r) => { setData(r.data); return r.data; }).catch((e) => onFail(e, opts.current, setData));
  }, [path, query]);
  useEffect(() => {
    const h = setTimeout(reload, delay);
    return () => clearTimeout(h);
  }, [reload, delay]);
  return { data, setData, reload };
};
